import Vue from "vue";

/*

*  使用方法：

*  将以下代码复制到一个js文件中，然后在入口文件main.js中import引入即可；

*  给elementUI的dialog上加上 v-dialogDrags

*  给dialog设置 :close-on-click-modal="false" , 禁止点击遮罩层关闭弹出层

*/
// v-dialogDrags: 弹窗拖拽属性 （重点！！！ 给模态框添加这个属性模态框就能拖拽了）
Vue.directive("dialogDrags", {
  // 属性名称dialogDrags，前面加v- 使用
  bind(el, binding, vnode, oldVnode) {
    const dragDom = el.querySelector(".el-dialog");
    const dialogHeaderEl = el.querySelector(".el-dialog__header");
    dragDom.style.cssText += ";padding:0px 40px 10px";
    dialogHeaderEl.style.cssText +=
      ";cursor:move;padding: 30px 20px 0px;-moz-user-select:none; -webkit-user-select:none;-ms-user-select:none;-khtml-user-select:none;user-select:none;";
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = (function () {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr];
      } else {
        return (dom, attr) => getComputedStyle(dom, false)[attr];
      }
    })();

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      const dragDomWidth = dragDom.offsetWidth;
      const dragDomHeight = dragDom.offsetHeight;

      const screenWidth = document.body.clientWidth;
      const screenHeight = document.body.clientHeight;

      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;

      // 获取到的值带px 正则匹配替换
      let styleLeftStr = sty(dragDom, "left");
      let styleTopStr = sty(dragDom, "top");
      if (!styleLeftStr || !styleTopStr) return;
      let styleLeft;
      let styleTop;
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (styleLeftStr.includes("%")) {
        styleLeft =
          +document.body.clientWidth * (+styleLeftStr.replace(/%/g, "") / 100);
        styleTop =
          +document.body.clientHeight * (+styleTopStr.replace(/%/g, "") / 100);
      } else {
        styleLeft = +styleLeftStr.replace(/px/g, "");
        styleTop = +styleTopStr.replace(/px/g, "");
      }

      document.onmousemove = function (e) {
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        // Handle edge cases
        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }
        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styleLeft}px;top:${
          top + styleTop
        }px`;
        dialogHeaderEl.style.cssText += ";cursor:move";
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  },
});



// WEBPACK FOOTER //
// ./src/url/drag.js